<template>
  <OmtStickedModal v-if="isOpen" @close="close" data-cy="refund-create-comments-modal">
    <OmtIcons
      :name="icon ? icon : 'check-circle'"
      size="2xl"
      mb="32px"
      :color="iconColor ? iconColor : 'var(--colors-light-support-success)'"
    />
    <OmtTypography as="h4-bold" mb="24px">
      {{ title }}
    </OmtTypography>

    <CFlex mb="24px">
      <OmtIcons name="square-poll-horizontal" mr="12px" />
      <OmtTypography as="h2-bold"> Protocolo: {{ protocol }} </OmtTypography>
    </CFlex>

    <CBox borderRadius="8px" bg="var(--colors-light-primary-light-gray)" p="12px 16px" mb="24px">
      <CFlex v-if="textSubtitle" mb="16px">
        <OmtIcons name="bell-on" mr="14px" />
        <OmtTypography as="h2-bold"> {{ textSubtitle }} </OmtTypography>
      </CFlex>
      <CBox v-if="textDescription">
        <OmtTypography as="p1" mb="16px"> {{ textDescription }} </OmtTypography>
      </CBox>
      <CBox v-else>
        <OmtTypography as="p1" mb="16px"> Você poderá acompanhar o status na tela de Autorizações. </OmtTypography>
      </CBox>
    </CBox>

    <OmtTypography as="h3-semi-bold" mb="16px" v-if="avaliation">
      Como você avalia sua experiência com esse serviço pelo APP Minha Omint?
    </OmtTypography>

    <CFlex justify="space-between" mb="8px" v-if="avaliation">
      <OmtButton
        :variant="rate === selectedRate ? 'solid' : 'outline'"
        width="48px"
        height="50px"
        border="0.5px solid var(--colors-light-secondary-divider)"
        borderRadius="50%"
        data-cy="rate-buttons"
        v-for="rate in 5"
        :key="rate"
        @click="selectRate(rate)"
      >
        <OmtTypography as="p1" :color="rate === selectedRate ? 'white' : 'inherit'"> {{ rate }} </OmtTypography>
      </OmtButton>
    </CFlex>

    <CFlex justify="space-between" mb="22px" v-if="avaliation">
      <OmtTypography as="p2"> Muito difícil </OmtTypography>
      <OmtTypography as="p2"> Muito fácil </OmtTypography>
    </CFlex>

    <template #footer>
      <OmtButton w="100%" @click="save" :disabled="avaliation && selectedRate === null">
        {{ buttonText ? buttonText : "Concluir" }}
      </OmtButton>
    </template>
  </OmtStickedModal>
</template>

<script>
/**
 * @prop {Boolean} isOpen
 * @prop {String} protocol
 * @prop {String} dueDate
 */
export default {
  props: {
    title: {
      Type: String
    },
    isOpen: {
      Type: Boolean
    },
    protocol: {
      Type: String
    },
    dueDate: {
      Type: String
    },
    avaliation: {
      Type: Boolean,
      default: true
    },
    textAlert: {
      Type: String
    },
    textDescription: {
      Type: String
    },
    icon: {
      Type: String
    },
    iconColor: {
      Type: String
    },
    buttonText: {
      Type: String
    }
  },
  data() {
    return {
      selectedRate: null
    };
  },
  computed: {
    textSubtitle() {
      if (this.textAlert) return this.textAlert;
      if (this.dueDate === "0") return null;
      if (this.dueDate === "1") return `A análise do pedido será feita em até 1 dia útil`;
      return `A análise do pedido será feita em até ${this.dueDate} dias úteis`;
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    save() {
      this.$emit("save", {
        ticket: this.protocol,
        type: "3",
        step: "S",
        rating: this.selectedRate
      });

      this.$emit("update:isOpen", false);
    },
    selectRate(rate) {
      this.selectedRate = rate;
    }
  }
};
</script>
